module.exports = __webpack_public_path__ + "static/shape_water-cd699685639109a7542ddb0ebc63f55e.png";